const boost = {
  // Page titles
  boostTitle: 'Boost Your Listing',
  boostSubtitle: 'Get your listing seen by more interested buyers',

  // Property reference
  boostingProperty: 'Boosting listing:',

  // Boost types
  featured: 'Featured Ad',
  featuredPlus: 'Featured Plus',

  // Labels
  recommended: 'Recommended',
  popular: 'Most Popular',
  days: 'days',
  month: 'month',

  // Features
  features: {
    higherRanking: 'Higher search ranking',
    featuredBadge: 'Featured badge on listing',
    highlighted: 'Highlighted in results',
    morePhotos: 'More photos and video',
    analytics: 'Detailed analytics',
    homepage: 'Homepage placement',
    aiOptimization: 'AI content optimization',
    prioritySupport: 'Priority support',
  },

  // Actions
  cancel: 'Cancel',
  continueToPayment: 'Continue to Payment',
  confirmBoost: 'Confirm Boost',
  boostNow: 'Boost Now',
  viewActiveBoosts: 'View Active Boosts',

  // Status
  active: 'Active',
  expired: 'Expired',
  pending: 'Pending',
  daysRemaining: 'days remaining',

  // Dashboard
  activeBoosts: 'Active Boosts',
  noActiveBoosts: 'No active boosts',
  boostHistory: 'Boost History',

  // Messages
  boostSuccess: 'Listing boosted successfully',
  boostError: 'Error boosting listing',

  // Payment
  paymentPending: 'Payment Pending',
  paymentComingSoon: 'Payment Coming Soon',
  paymentApiPending: 'Payment service will be activated soon. We are working on connecting the payment gateway.',
};

export default boost;
